export default __webpack_public_path__ + "static/media/fpa50200.9c0bb5a5.png";